import { Fragment, useEffect, useState } from "react";
import { Box, Divider, Stack, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import API from "../../api/axiosConfig";

export default function CandidateReferralList() {
  const [loading, setLoading] = useState(false);
  const [referrals, setReferrals] = useState([]);

  const getCandidateReferrals = async () => {
    setLoading(true);
    try {
      const response = await API.post("api/candidates/getReferrals");
      setReferrals(response.data.candidates);
    } catch (error) {
      console.log("Error fetching user's candidate referrals!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCandidateReferrals();
  }, []);

  return (
    <Box sx={{ width: "100%", boxSizing: "border-box" }}>
      <Typography
        variant="h6"
        fontWeight="700"
        sx={(theme) => ({
          mb: 3,
          textAlign: "left",
          color: theme.palette.paper.light,
          borderBottom: "1px solid",
          borderColor: "divider",
          pb: 1
        })}
      >
        Your Candidate Referrals
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : referrals.length > 0 ? (
        <Stack spacing={3} sx={{ width: "100%" }}>
          {referrals.map((candidate, index) => (
            <Fragment key={candidate.id}>
              <Box
                sx={{
                  position: "relative",
                  borderRadius: 2,
                  p: 2,
                  width: "100%",
                  boxSizing: "border-box",
                }}
              >
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "1.2fr 1.2fr 1fr" },
                    gap: 3,
                    alignItems: "start",
                    width: "100%",
                  }}
                >
                  {/* CANDIDATE NAME COLUMN */}
                  <Box sx={{ minWidth: 0, textAlign: "left" }}>
                    <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ display: "block", mb: 0.5, textTransform: "uppercase" }}>
                      Candidate Name
                    </Typography>
                    <Typography variant="body2" fontWeight="600" color="text.primary" sx={{ wordBreak: "break-word" }}>
                      {candidate.name}
                    </Typography>
                  </Box>

                  {/* EMAIL COLUMN */}
                  <Box sx={{ minWidth: 0, textAlign: "left" }}>
                    <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ display: "block", mb: 0.5, textTransform: "uppercase" }}>
                      Email Address
                    </Typography>
                    <Typography variant="body2" color="text.primary" sx={{ wordBreak: "break-word", fontStyle: "italic" }}>
                      {candidate.email}
                    </Typography>
                  </Box>

                  {/* CLEARANCE STATUS COLUMN */}
                  <Box sx={{ minWidth: 0, textAlign: "left" }}>
                    <Typography variant="caption" fontWeight="bold" color="text.secondary" sx={{ display: "block", mb: 0.5, textTransform: "uppercase" }}>
                      Security Clearance
                    </Typography>
                    <Typography 
                      variant="body2" 
                      fontWeight="600"
                      sx={{ 
                        color: candidate.clearanceType && candidate.clearanceType !== "None" ? "primary.main" : "text.secondary"
                      }}
                    >
                      {candidate.clearanceType || "None"}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {index < referrals.length - 1 && (
                <Divider sx={{ my: 1 }} />
              )}
            </Fragment>
          ))}
        </Stack>
      ) : (
        <Typography
          variant="body2"
          sx={(theme) => ({
            textAlign: "center",
            fontStyle: "italic",
            color: theme.palette.paper.verylight,
            py: 2
          })}
        >
          No candidate referrals found.
        </Typography>
      )}
    </Box>
  );
}
